import {Component, OnInit} from '@angular/core';
import {Team} from '../../admin/models/team.model';
import {HrService} from '../hr.service';
import {FabMessageService} from '@fabric/components/message';
import {PersonalService} from '../../personal/personal.service';
import {MatDialogRef} from '@angular/material/dialog';
import {AuthenticationService} from '../../core/authentication/authentication.service';
import {Employee} from '../../admin/models/employee.model';
import {HttpErrorResponse} from '@angular/common/http';

@Component({
    selector: 'app-new-team-pop-up',
    templateUrl: './new-team-pop-up.component.html',
    styleUrls: ['./new-team-pop-up.component.scss']
})
export class NewTeamPopUpComponent implements OnInit {

    public peopleSearchResults: any [] = [];
    public altSearchResults: any [] = [];
    public selectedPerson: any;
    public altSelectedPerson: any;
    public searchSubscription: any;
    public model = {} as Employee;
    public manager: any;
    public alternateManager: any;
    public teamDetails = {} as Team;
    public isPageLoading = false;

    constructor(
        private readonly hrService: HrService,
        private readonly fabMessageService: FabMessageService,
        private readonly personalService: PersonalService,
        private readonly authService: AuthenticationService,
        public dialogRef: MatDialogRef<[]>) {
    }

    ngOnInit(): void {
        this.teamDetails.updatedBy = this.authService.userInfo.gmin || '';
    }

    /**
     * Submits the form to create a teams details.
     */
    submitForm(): void {
        this.isPageLoading = true;
        this.hrService.saveTeam(this.teamDetails).subscribe({
            next: () => {
                this.fabMessageService.displayMessage('Request submitted successfully');
                this.isPageLoading = false;
                this.close();
            }, error: (err: HttpErrorResponse) => {
                this.fabMessageService.displayErrorMessage(err.error.errorMessage);
                this.isPageLoading = false;
            }
        });
    }

    /**
     * Closes the popup
     */
    close(): void {
        this.dialogRef.close();
    }

    /**
     * This will call the search method once the user has populated
     * the search box with 4 characters.
     */
    onAddMemberChanged() {
        this.selectedPerson = undefined;
        const minimumLengthToSearch = 3;
        if (this.manager.length < minimumLengthToSearch) {
            this.peopleSearchResults = [];
        }
        if (this.searchSubscription) {
            this.searchSubscription.unsubscribe();
        }
        if (this.manager.length > minimumLengthToSearch) {
            this.search();
        }
    }

    /**
     * This will call the search method once the user has populated
     * the search box with 4 characters.
     */
    onAddAltMemberChanged() {
        this.altSelectedPerson = undefined;
        const minimumLengthToSearch = 3;
        if (this.alternateManager.length < minimumLengthToSearch) {
            this.altSearchResults = [];
        }
        if (this.searchSubscription) {
            this.searchSubscription.unsubscribe();
        }
        if (this.alternateManager.length > minimumLengthToSearch) {
            this.altSearch();
        }
    }

    /**
     * This uses the result of the search function to
     * populate the form with the persons details.
     * @param person the person to populate the form
     */
    personSelected(person: any) {
        this.manager = (person.displayName);
        this.peopleSearchResults = [];
        this.selectedPerson = person;
        this.teamDetails.manager = this.selectedPerson.gmin;
        this.teamDetails.managerEmail = this.selectedPerson.email;
    }

    /**
     * This uses the result of the search function to
     * populate the form with the persons details.
     * @param person the person to populate the form
     */
    altPersonSelected(person: any) {
        this.alternateManager = (person.displayName);
        this.altSearchResults = [];
        this.altSelectedPerson = person;
        this.teamDetails.alternateManager = this.altSelectedPerson.gmin;
        this.teamDetails.alternateManagerEmail = this.altSelectedPerson.email;
    }

    /**
     * Calls the search for employees method in the hr service
     * returns an error response if it is not working
     * @private
     */
    private search() {
        this.isPageLoading = true;
        this.searchSubscription = this.hrService.searchForEmployees(this.manager).subscribe({
            next: response => {
                if (response.body !== null) {
                    this.peopleSearchResults = response.body;
                }
                this.isPageLoading = false;
            },
            error: () => {
                this.fabMessageService.displayErrorMessage('PeopleService Unavailable');
                this.isPageLoading = false;
            }
        });
    }

    /**
     * Calls the search for employees method in the hr service
     * returns an error response if it is not working
     * @private
     */
    private altSearch() {
        this.isPageLoading = true;
        this.searchSubscription = this.hrService.searchForEmployees(this.alternateManager).subscribe({
            next: response => {
                if (response.body !== null) {
                    this.altSearchResults = response.body;
                }
                this.isPageLoading = false;
            },
            error: () => {
                this.fabMessageService.displayErrorMessage('PeopleService Unavailable');
                this.isPageLoading = false;
            }
        });
    }

    /**
     * makes a call to a method in the hr service to get photo Url
     * @param userGmin id used to locate photo
     */
    getPhoto(userGmin: string): string {
        return this.hrService.getPhotoUrl(userGmin);
    }

    /**
     * makes a call to a method in the hr service to display the default image
     * @param event onclick or keyup
     */
    displayDefaultImage(event: any) {
        this.hrService.displayDefaultImage(event);
    }
}
